import { render, staticRenderFns } from "./skeletonNav.vue?vue&type=template&id=c241bf38&scoped=true"
var script = {}
import style0 from "./skeletonNav.vue?vue&type=style&index=0&id=c241bf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c241bf38",
  null
  
)

export default component.exports